/**
 * 登录后写入 localStorage 的 CRM_CURRENCY_ID（见 login.vue、keys.js）
 * 1：人民币展示 ￥ · 2：美元展示 $
 */
import { CRM_CURRENCY_ID } from '@/util/keys';

export const CRM_CURRENCY_CNY = 1;
export const CRM_CURRENCY_USD = 2;

export function getCrmCurrencyId() {
  if (typeof localStorage === 'undefined') return CRM_CURRENCY_CNY;
  const raw = localStorage.getItem(CRM_CURRENCY_ID);
  if (raw === null || raw === '') return CRM_CURRENCY_CNY;
  const n = Number(raw);
  return n === CRM_CURRENCY_USD ? CRM_CURRENCY_USD : CRM_CURRENCY_CNY;
}

export function getCrmCurrencySymbol() {
  return getCrmCurrencyId() === CRM_CURRENCY_USD ? '$' : '￥';
}

/** 金额后是否缀「元」（人民币习惯）；美元不缀 */
export function getCrmCurrencyAmountSuffix() {
  return getCrmCurrencyId() === CRM_CURRENCY_USD ? '' : '元';
}
